import { Filter } from "@/common/model/Filter";

export class CalculationFilter extends Filter {
  constructor() {
    super("calculation-filter");
  }

  toQueryParam(): string {
    return "";
  }

  clear(): void {}
}
